export const LS_ACCESS_TOKEN_KEY = "garther_access_token";
export const LS_REFRESH_TOKEN_KEY = "garther_refresh_token";
export const LS_REFERRAL_CODE_KEY = "ref_code";
export const SS_LINKING_ACCOUNT = "is_linking_account";
